module.exports = __webpack_public_path__ + "img/banner-004.4ad64dac.png";